import { isOneOf } from './isOneOf';
import type { TraceErrorObject } from 'owa-trace';

// Graphql does not use http status to indicate if this is a server error or client error like REST. It returns everything as 200 for server processing error.
// According to https://graphql-dotnet.github.io/docs/getting-started/errors/, GraphQL could return three group errors:schema errors, input errors and processing errors.
// Except for the known codes, any other thrown error is treated as a processing error. OWA will mark processing error as server error while all other errors as client errors.
const NonGraphQLProcessingErrorCodes: string[] = [
    'NoOperationError',
    'SyntaxError',
    'InvalidOperationError',
    'InvalidVariableError',
    'UNIQUE_OPERATION_NAMES',
    'LONE_ANONYMOUS_OPERATION',
    'SINGLE_ROOT_FIELD_SUBSCRIPTIONS',
    'FIELDS_ON_CORRECT_TYPE',
    'OVERLAPPING_FIELDS_CAN_BE_MERGED',
    'SCALAR_LEAFS',
    'KNOWN_ARGUMENT_NAMES',
    'UNIQUE_ARGUMENT_NAMES',
    'PROVIDED_NON_NULL_ARGUMENTS',
    'UNIQUE_FRAGMENT_NAMES',
    'KNOWN_TYPE_NAMES',
    'FRAGMENTS_ON_COMPOSITE_TYPES',
    'NO_UNUSED_FRAGMENTS',
    'KNOWN_FRAGMENT_NAMES',
    'NO_FRAGMENT_CYCLES',
    'POSSIBLE_FRAGMENT_SPREADS',
    'ARGUMENTS_OF_CORRECT_TYPE',
    'DEFAULT_VALUES_OF_CORRECT_TYPE',
    'UNIQUE_INPUT_FIELD_NAMES',
    'KNOWN_DIRECTIVES',
    'DIRECTIVES_IN_ALLOWED_LOCATIONS',
    'UNIQUE_DIRECTIVES_PER_LOCATION',
    'UNIQUE_VARIABLE_NAMES',
    'VARIABLES_ARE_INPUT_TYPES',
    'NO_UNDEFINED_VARIABLES',
    'NO_UNUSED_VARIABLES',
    'VARIABLES_IN_ALLOWED_POSITION',
    'undefined', // we do not treat undefined as the server error as well.
];

export function isGraphQLProcessingError(error?: TraceErrorObject) {
    // Check if the error object has an extensions object and the extensions object has code.
    // If not, we will let the regular datapoint categorize the error further
    if (error?.extensions?.code == null) {
        return false;
    }

    return !isOneOf(NonGraphQLProcessingErrorCodes, error.extensions.code);
}
